import { useQuery } from "@tanstack/react-query";

import { ChartData } from "../../../../models/ChartCollectionData";
import DataSvc from "../../../../services/dataSvc";

/**
 * Takes in a chart collection ID,
 * fetches the chart collection data,
 * and returns the first line (time based) graph without groupings.
 * For use in the facility details page.
 */
export const useIndividualFacilityChart = (
  chartCollectionId: number | undefined
) => {
  const query = useQuery<ChartData>(
    ["chartData", chartCollectionId],
    async () => {
      const chartCollections = await DataSvc.getChartCollectionsByCollectionId(
        chartCollectionId?.toString()
      );
      // Filter for line (time based) graphs without groupings
      const filteredCollections = chartCollections
        .filter(({ type, aggregation, grouping1, grouping2 }: ChartData) => {
          return (
            type === "line" &&
            (aggregation === "sum" || aggregation === "avg") &&
            grouping1 === null &&
            grouping2 === null
          );
        })
        .map((chart) => ({
          ...chart,
          name: chart.name.replace("全施設 ", ""),
        }));

      // There should only be one line (time based) graph without groupings
      return filteredCollections[0];
    },
    {
      enabled: !!chartCollectionId,
    }
  );

  return query;
};
